import { createSelector } from 'reselect';
import { makeSelectCurrentLang } from '../MetadataProvider/selectors';
import { locales } from '~/utils';
import Config from '~/config';
import {
  initialState as detailInitialState,
  initStateDownloadPhoto as downloadInitialState,
} from './reducer';

const selectAIDetailPhoto = state =>
  state.aiPhoto ? state.aiPhoto.detail : detailInitialState;

const selectDownloadPhoto = state =>
  state.aiPhoto ? state.aiPhoto.download : downloadInitialState;

const makeSelectPhoto = () =>
  createSelector(
    selectAIDetailPhoto,
    photoDetailState => photoDetailState.photo
  );

const makeSelectPhotoLoading = () =>
  createSelector(
    selectAIDetailPhoto,
    photoDetailState => photoDetailState.loading
  );

const makeSelectRemainingDownloads = () =>
  createSelector(
    selectAIDetailPhoto,
    photoDetailState => photoDetailState.remainingDownloads
  );

const makeSelectDownloadPhotoLoading = () =>
  createSelector(
    selectDownloadPhoto,
    photoDownloadState => photoDownloadState.loading
  );

const makeSelectCurrentDownloadingPhotoURLs = () =>
  createSelector(
    selectDownloadPhoto,
    photoDownloadState => photoDownloadState.currentDownloadingPhotoURLs
  );

export {
  makeSelectPhoto,
  makeSelectPhotoLoading,
  makeSelectDownloadPhotoLoading,
  makeSelectCurrentDownloadingPhotoURLs,
  makeSelectRemainingDownloads,
};
